export const LIGHT_THEME = 'LIGHT_THEME';
export const DARK_OR_LIGHT = 'DARK_OR_LIGHT';

export const THEME_COLOR = 'THEME_COLOR';
export const BLUE_THEME = 'BLUE_THEME';
export const ORIGINAL_THEME = 'ORIGINAL_THEME';

export const DIRECTION = 'DIRECTION';
